import { DEFAULT_LANGUAGE, getLanguage, resolveSupportedLanguage } from '@/constants/languages';

/**
 * Mirror the active interface language onto `<html>` (FR-13, FR-23).
 *
 * `lang` picks the screen reader's voice — without it VoiceOver reads Korean
 * copy in English. `dir` drives the browser's bidi layout. Both come from the
 * registry, so direction is declared in one place. Unresolvable tags fall back
 * to English, matching i18next's `fallbackLng`.
 */
export const applyDocumentLanguage = (rawLanguage: string | null | undefined): void => {
  if (typeof document === 'undefined') return;

  const code = resolveSupportedLanguage(rawLanguage ?? null) ?? DEFAULT_LANGUAGE;
  const row = getLanguage(code);

  const element = document.documentElement;
  element.setAttribute('lang', code);
  element.setAttribute('dir', row?.dir ?? 'ltr');
};
